// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Constants
import { GPA_CHART_COLORS } from "src/constants/enums";

export default function GPAChartLegend() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Typography fontSize="14px">{t("Legend")}</Typography>
      <Grid container display="flex" rowSpacing="8px" columnSpacing="16px">
        {/* Circle shape */}
        <Grid item display="flex" alignItems="center" gap="8px">
          <div
            style={{
              width: "10px",
              height: "10px",
              backgroundColor: GPA_CHART_COLORS.unflagged,
              borderRadius: "50%",
            }}
          ></div>
          <Typography fontSize="12px">{t("Unflagged point")}</Typography>
        </Grid>
        {/* Triangle shape */}
        <Grid item display="flex" alignItems="center" gap="8px">
          <div style={{ color: GPA_CHART_COLORS.flagged_once }}>△</div>
          <Typography fontSize="12px">
            {t("Progression flagged once")}
          </Typography>
        </Grid>
        {/* Triangle shape */}
        <Grid item display="flex" alignItems="center" gap="8px">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "16px",
              height: "24px",
              color: GPA_CHART_COLORS.flagged_twice,
            }}
          >
            {"\u25ed"}
          </div>
          <Typography fontSize="12px">
            {t("Progression flagged twice (repeatable)")}
          </Typography>
        </Grid>

        <Grid
          item
          container
          xs={12}
          display="flex"
          rowSpacing="8px"
          columnSpacing="16px"
        >
          {/* Triangle shape */}
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "16px",
                color: GPA_CHART_COLORS.flagged_multiple,
              }}
            >
              ▲
            </div>
            <Typography fontSize="12px">
              {t("Progression flagged ≥ 3 times (confirmed)")}
            </Typography>
          </Grid>

          {/* X shape */}
          <Grid item display="flex" alignItems="center" gap="8px">
            <div style={{ width: "16px", color: GPA_CHART_COLORS.deep_loss }}>
              X
            </div>
            <Typography fontSize="12px">
              {t("Deep loss at baseline")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
